var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84766 0C5.6186 0 2.90148 2.49085 2.52729 5.79403L2.18242 8.8385C2.09672 9.59498 1.79012 10.3069 1.30315 10.88C0.269743 12.0964 1.10847 14 2.67779 14H15.0175C16.5868 14 17.4256 12.0964 16.3922 10.88C15.9052 10.3069 15.5986 9.59499 15.5129 8.8385L15.168 5.79403C14.7938 2.49085 12.0767 0 8.84766 0ZM11.8198 16.0715C11.3624 17.1992 10.2042 18 8.84766 18C7.49112 18 6.33291 17.1992 5.87555 16.0715C5.85648 16.0245 5.84766 15.974 5.84766 15.9233C5.84766 15.6895 6.03717 15.5 6.27094 15.5H11.4244C11.6581 15.5 11.8477 15.6895 11.8477 15.9233C11.8477 15.974 11.8388 16.0245 11.8198 16.0715Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e28fa771.svg";
export { ForwardRef as ReactComponent };